// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentTextField_root__BWjxf","input":"PaymentTextField_input__z4JH1","amountPostfix":"PaymentTextField_amountPostfix__uVJ4_"};